<section class="sign-up-container">
	<app-sign-up-referral-code></app-sign-up-referral-code>
</section>
